import { useLayoutEffect, useState } from 'react';
import debounce from 'react-utils/debounce';
function getSize() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}

/**
 * @description Useful for retrieving and tracking the dimensions of the browser window. Useful for:
 * - Calculating available space
 * - Conditional rendering based on viewport dimensions. Prefer `useMedia` for this use case. `useMedia` is more performant as it does not require a re-render on every resize.
 *
 * @see `useMedia`
 */
export function useWindowSize() {
  const [size, setSize] = useState(getSize());
  useLayoutEffect(() => {
    const handleResize = debounce(() => {
      setSize(getSize());
    }, 200);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return size;
}